<template>
  <div 
    ref="follower" 
    class="follower"
    :class="{ over: allis.isMouseOver, down: allis.isMouseDragging, disabled: allis.mouseFollowerDisabled }"
  >{{  allis.mouseFollowerText }}</div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { isMobile } from 'mobile-device-detect'
import { TweenLite } from 'gsap';
import { useAllisStore } from '../../stores/allis';

export default {
  setup() {
    if(!isMobile){
      const follower = ref(null);
      const allis = useAllisStore();

      const moveCircle = (e) => {
        const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;

        TweenLite.to(follower.value, 0.3, {
            css: {
              left: e.pageX - scrollX,
              top: e.pageY - scrollY
            }
          });
      };

      onMounted(() => {
        window.addEventListener('mousemove', moveCircle);
      });

      onUnmounted(() => {
        window.removeEventListener('mousemove', moveCircle);
      });

      return {
        follower,
        allis
      };
    }
  }
};
</script>

<style lang="scss">
.follower {
  position: fixed;
  width: 1px;
  height: 1px;
  opacity: 0;
  top: 50%;
  left: 50%;
  /* margin: -50px 0 0 -50px; */
  transform: translate(-50%, -50%);
  background-color: rgba(255,255,255,0.1);
  border: 2px solid white;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 80%;
  backface-visibility: hidden;
  pointer-events: none;
  transition: opacity .5s ease, height .5s ease, width .5s ease, font-size .25s ease, color .5s ease, border-color .5s ease;
  text-transform: uppercase;
  font-family: var(--fontSerifItSb);
  font-size: 0;
  z-index: 999;
  text-align: center;
  &.over {
    width: 10.3rem;
    height: 10.3rem;
    opacity: 1;
    font-size: 2.1rem;
    transition: opacity .5s ease, height .5s ease, width .5s ease, font-size .25s ease, color .5s ease, border-color .5s ease;
  }
  &.disabled {
    // background-image: url('/allisstudio/wp-content/themes/allisstudio-v2/build/images/svgs/mouse-disabled-50.svg');
    opacity: 0.5;
    font-size: 2rem;
    // border-color: #808080;
    // color: #808080;
  }
  &.down {
    transition: opacity .25s ease, height .25s ease, width .25s ease;
  }
}
</style>
